import { createSelector } from "reselect";

const articuloReducerDataSelector = (state) => state.articuloReducer.getIn(["data"]).toJS();
export const articuloDataSelector = createSelector(articuloReducerDataSelector, (dataField) => {
  // armo el artículo completo
  let myArticuloCompleto = undefined;
  if (dataField.articuloCompleto) {
    myArticuloCompleto = dataField.articuloCompleto;

    // cargo las imágenes de los artículos
    for (var i = 0; i < myArticuloCompleto.listaImagenesArticulos.length; i++) {
      // cargo la imagen recortada
      let articuloImagen = dataField.articuloImagenes.find((ia) => {
        if (ia.idArticuloImagen === myArticuloCompleto.listaImagenesArticulos[i].idImagen)
          return ia;
      });
      myArticuloCompleto.listaImagenesArticulos[i].imagen = undefined;
      if (articuloImagen !== undefined)
        myArticuloCompleto.listaImagenesArticulos[i].imagen = articuloImagen.imagen;

      // cargo la imagen original
      let articuloImagenOriginal = dataField.articuloImagenesOriginales.find((ia) => {
        if (ia.idArticuloImagen === myArticuloCompleto.listaImagenesArticulos[i].idImagen)
          return ia;
      });

      // busco el item de imagen original que se corresponde con el id de imagen de recorte
      let itemImagenOriginalArticulo = myArticuloCompleto.listaImagenesOriginalesArticulos.find(
        (item) => {
          if (item.idImagen === myArticuloCompleto.listaImagenesArticulos[i].idImagen) return item;
        }
      );
      itemImagenOriginalArticulo.imagen = undefined;
      if (articuloImagenOriginal !== undefined)
        itemImagenOriginalArticulo.imagen = articuloImagenOriginal.imagen;
    }

    // cargo las imágenes de los stock
    for (var j = 0; j < myArticuloCompleto.stock.length; j++) {
      var item = myArticuloCompleto.stock[j];
      // vargo la imagen recortada
      let stockImagen = dataField.stockImagenes.find((si) => {
        if (si.idTalleColor === item.listIdTalleColor[0]) return si;
      });
      item.imagen = undefined;
      if (stockImagen !== undefined) {
        item.imagen = stockImagen.imagen;
        myArticuloCompleto.stock[j].imagen = stockImagen.imagen;
      }
    }
  }

  let listadoArticulo = undefined;
  if (dataField.listadoArticulo !== undefined) {
    listadoArticulo = dataField.listadoArticulo;
    listadoArticulo.listaSuperRubros.map((sr) => {
      sr.listaRubros.map((rub) => {
        rub.listaSubRubros.map((subRub) => {
          subRub.listaArticulos.map((arti) => {
            if (
              dataField.articuloImagenesListado !== undefined &&
              dataField.articuloImagenesListado.length > 0
            ) {
              let imagenesArticulo = dataField.articuloImagenesListado.find((ia) => {
                if (ia.idArticulo == arti.idArticulo) return ia;
              });
              arti.listaImagenesArticulos =
                imagenesArticulo != undefined ? imagenesArticulo.imagenes : undefined;
            }
          });
        });
      });
    });
  }

  return {
    tipotalle: dataField.tipotalle,
    articuloCompleto: myArticuloCompleto,
    articuloBorrado: dataField.articuloBorrado,
    cantidadImagenesCargadas: dataField.articuloImagenes.length,
    cantidadImagenesOriginalesCargadas: dataField.articuloImagenesOriginales.length,
    cantidadImagenesStockCargadas: dataField.stockImagenes.length,
    contadorImagenesEnviadasAtemporal: dataField.contadorImagenesEnviadasAtemporal,
    listadoArticulo: dataField.listadoArticulo,
    imagenesListado: dataField.articuloImagenesListado,
    filtrosArticulo: dataField.filtrosArticulo,
  };
});
